//const baseURL = 'http://localhost:8800'
// const baseURL = 'http://47.97.192.100:83';
const baseURL = '/omics-http';

const xdlURL  = baseURL + '/xdl';
const rdkURL  = baseURL + '/rdk';
const dzxURL  = baseURL + '/dzx';
const rURL    = baseURL + '/r';

export default {
  dzxURL,
  xdlURL,
  rURL,
  rdkURL
}




// WEBPACK FOOTER //
// ./src/api.js